import { layout, spacing } from '$tablet-app/src/app/theme';
import React, { FC, ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';

interface Props {
  left?: ReactNode;
  center?: ReactNode;
  right?: ReactNode;
  bottom?: ReactNode;
}

const DialogHeader: FC<Props> = (props) => {
  return (
    <View style={styles.header}>
      <View style={styles.headerTop}>
        <View>{props.left}</View>
        <View style={styles.center}>{props.center}</View>
        <View>{props.right}</View>
      </View>

      {props.bottom}
    </View>
  );
};

// Styles
const styles = StyleSheet.create({
  header: {
    padding: spacing[3],
  },
  headerTop: {
    ...layout.verticallyCenteredRow,
    justifyContent: 'space-between',
  },
  center: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default DialogHeader;
